var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCollabIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18964",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18964",
    transform: "translate(-3734 18238)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18962",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18962",
    transform: "translate(-70 12)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17430",
    "data-name": "\\u9577\\u65B9\\u5F62 17430",
    width: 38,
    height: 38,
    transform: "translate(3804 -18250)",
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_18963",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 18963",
    transform: "translate(5 -10.743)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17431",
    "data-name": "\\u9577\\u65B9\\u5F62 17431",
    width: 15,
    height: 15,
    rx: 3,
    transform: "translate(3732 -18224.258)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17434",
    "data-name": "\\u9577\\u65B9\\u5F62 17434",
    width: 15,
    height: 15,
    rx: 3,
    transform: "translate(3732 -18207.258)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17432",
    "data-name": "\\u9577\\u65B9\\u5F62 17432",
    width: 15,
    height: 15,
    rx: 3,
    transform: "translate(3749 -18224.258)"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u9577\\u65B9\\u5F62_17433",
    "data-name": "\\u9577\\u65B9\\u5F62 17433",
    width: 15,
    height: 15,
    rx: 3,
    transform: "translate(3749 -18207.258)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCollabIcon);
export default __webpack_public_path__ + "static/media/collabIcon.fd75292904b712417c32934387871074.svg";
export { ForwardRef as ReactComponent };